module.exports = __webpack_public_path__ + "static/media/WP_20170514_002.149e48ed.jpg";